import * as React from 'react';
import { UIText1, ModalWindow } from '@cian/ui-kit';
import { IconFunctionalSuccess16, IconActionSort24 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './SortingMobile.css';
import { ISortingProps } from '../../types';

export const SortingMobile: React.FC<ISortingProps> = ({ disabled, onChange, options, selectedOption }) => {
  const [isOpenModal, setIsOpenModal] = React.useState(false);

  const toggleOpenModal = React.useCallback(() => setIsOpenModal(prev => !prev), []);

  const handleSelectOption = React.useCallback(
    (event: React.MouseEvent) => {
      const index = Number(event.currentTarget.getAttribute('data-index'));
      const nextOption = options[index];

      if (!selectedOption || nextOption.value !== selectedOption.value) {
        onChange(nextOption);
      }

      setIsOpenModal(false);
    },
    [onChange, selectedOption, options],
  );

  return (
    <>
      <button
        className={styles['sort-button']}
        onClick={toggleOpenModal}
        disabled={disabled}
        type="button"
        aria-label="Сортировка"
      >
        <IconActionSort24 color="icon-main-default" />
      </button>
      <ModalWindow title="Сначала показывать" size="XS" open={isOpenModal} onClose={toggleOpenModal} maxWidth={400}>
        <div className={styles['modal-content']}>
          <ul className={styles['options-list']} role="listbox">
            {options.map((option, idx) => {
              const isSelected = (selectedOption && option.value === selectedOption.value) || false;

              return (
                <li
                  className={styles['option']}
                  role="option"
                  aria-checked={isSelected}
                  key={option.value}
                  data-index={idx}
                  data-value={option.value}
                  onClick={handleSelectOption}
                >
                  <UIText1>{option.label}</UIText1>
                  <span className={styles['check']}>
                    {isSelected && <IconFunctionalSuccess16 color="icon-main-default" />}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </ModalWindow>
    </>
  );
};
